export function filterUnique<T>(item: T, index: number, array: T[]): boolean {
    return array.indexOf(item) === index;
}

export function unique<T>(array: T[]): T[] {
    return array.filter(filterUnique);
}

export function randomElement<T>(array: T[]): T {
    return array[Math.floor(Math.random() * array.length)];
}

export function elementsMatch<A>(a: A[], b: A[]): boolean {
    return a.every((v) => b.includes(v)) && b.every((v) => a.includes(v));
}
